import React from 'react'
import PricingView from './PricingView'
import type { MeResponse } from '../../api/me'

type PricingPublicPageProps = {
  me?: MeResponse | null
  isLoggedIn: boolean
}

const PricingPublicPage: React.FC<PricingPublicPageProps> = ({ me, isLoggedIn }) => (
  <PricingView variant="public" me={me} isLoggedIn={isLoggedIn} />
)

export default PricingPublicPage
